import { addRequest, removeRequest } from "store/LoadingStore/loadingSlice";
import { AppThunk } from "../rootStore";
import {
  setClinicList,
  setClinicUserList,
  setLoading,
  setOffset,
  setLimit,
  setTotal,
  setSortConfig,
} from "./clinicSlice";
import { Requests } from "../../types/requests";
import { CommonApiParams } from "types/common";
import { ClinicRepository } from "repositories/ClinicRepository";
import {
  SUPER_ADMIN_CLINIC_LIMIT,
  SUPER_ADMIN_USER_CLINIC_LIMIT,
} from "constants/dashboard";
import { changeSort } from "utils/general";

export const getClinicList =
  (callback?: () => void): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      dispatch(addRequest(Requests.getClinicList));

      const {
        clinic: { limit, offset, sortConfig },
      } = getState();

      const apiParams: CommonApiParams = {
        ...(sortConfig.sortBy !== "" && {
          sortBy: sortConfig.sortBy,
          sortDirection: sortConfig.sortDirection,
        }),
        limit,
        offset,
      };
      const clinicRepository = ClinicRepository.getInstance();
      const cliniciansList = await clinicRepository.getClinicList(apiParams);
      const items = cliniciansList?.items;

      dispatch(setClinicList(items));
      dispatch(setTotal(cliniciansList?.totalCount));
      dispatch(setLimit(SUPER_ADMIN_CLINIC_LIMIT));
    } catch (error) {
      console.log("Error from getClinicList Thunk", error);
    } finally {
      dispatch(setLoading(false));
      dispatch(removeRequest(Requests.getClinicList));

      if (callback) callback();
    }
  };

export const loadMoreClinics = (): AppThunk => async (dispatch, getState) => {
  try {
    const clinicRepository = ClinicRepository.getInstance();
    const {
      clinic: { limit, offset, clinicList, sortConfig, total },
    } = getState();
    if (total <= offset + limit) {
      return;
    }
    dispatch(addRequest(Requests.loadMoreClinics));
    const newOffset = offset + limit;
    const apiParams: CommonApiParams = {
      ...(sortConfig.sortBy !== "" && {
        sortBy: sortConfig.sortBy,
        sortDirection: sortConfig.sortDirection,
      }),
      limit,
      offset: newOffset,
    };

    const clinics = await clinicRepository.getClinicList(apiParams);
    const items = clinics.items;
    const totalItems = [...(clinicList ?? []), ...items];
    dispatch(setClinicList(totalItems));
    dispatch(setOffset(newOffset));
  } catch (error) {
    console.log(error);
  } finally {
    dispatch(removeRequest(Requests.loadMoreClinicians));
  }
};

export const changeSortOfClinicList =
  (sortBy: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      const {
        clinic: { sortConfig },
      } = getState();

      const changedSortConfig = changeSort(sortBy, sortConfig);

      dispatch(setSortConfig(changedSortConfig));
      dispatch(setOffset(0));

      dispatch(getClinicList());
    } catch (error) {
      console.log(error);
    }
  };

export const getClinicUserList =
  (callback?: () => void): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      dispatch(addRequest(Requests.getClinicUserList));

      const {
        clinic: { limit, offset, sortConfig },
      } = getState();

      const apiParams: CommonApiParams = {
        ...(sortConfig.sortBy !== "" && {
          sortBy: sortConfig.sortBy,
          sortDirection: sortConfig.sortDirection,
        }),
        limit,
        offset,
      };
      const clinicRepository = ClinicRepository.getInstance();
      const clinicUserList = await clinicRepository.getClinicUserList(
        apiParams
      );
      const items = clinicUserList?.items;

      dispatch(setClinicUserList(items));
      dispatch(setTotal(clinicUserList?.totalCount));
      dispatch(setLimit(SUPER_ADMIN_USER_CLINIC_LIMIT));
    } catch (error) {
      console.log("Error from getClinicUserList Thunk", error);
    } finally {
      dispatch(setLoading(false));
      dispatch(removeRequest(Requests.getClinicUserList));

      if (callback) callback();
    }
  };

export const loadMoreClinicUsers =
  (): AppThunk => async (dispatch, getState) => {
    try {
      const clinicRepository = ClinicRepository.getInstance();
      const {
        clinic: { limit, offset, clinicUserList, sortConfig, total },
      } = getState();
      if (total <= offset + limit) {
        return;
      }
      dispatch(addRequest(Requests.loadMoreClinicUsers));
      const newOffset = offset + limit;
      const apiParams: CommonApiParams = {
        ...(sortConfig.sortBy !== "" && {
          sortBy: sortConfig.sortBy,
          sortDirection: sortConfig.sortDirection,
        }),
        limit,
        offset: newOffset,
      };

      const clinics = await clinicRepository.getClinicUserList(apiParams);
      const items = clinics.items;
      const totalItems = [...(clinicUserList ?? []), ...items];
      dispatch(setClinicUserList(totalItems));
      dispatch(setOffset(newOffset));
    } catch (error) {
      console.log(error);
    } finally {
      dispatch(removeRequest(Requests.loadMoreClinicUsers));
    }
  };

export const changeSortOfClinicUserList =
  (sortBy: string): AppThunk =>
  async (dispatch, getState) => {
    try {
      const {
        clinic: { sortConfig },
      } = getState();

      const changedSortConfig = changeSort(sortBy, sortConfig);

      dispatch(setSortConfig(changedSortConfig));
      dispatch(setOffset(0));

      dispatch(getClinicUserList());
    } catch (error) {
      console.log(error);
    }
  };
